const state = {
  aceite: null,
};
const mutations = {
  ACEITE_TERMO(state, value) {
    state.aceite = value.aceite;
  },
};

const actions = {
  detalharTermoDeUso: async (context, { termoDeUsoId }) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.get(`/tdu/termo-uso/${termoDeUsoId}`, {
      termoDeUsoId,
    });

    return resposta;
  },

  listarTermosDeUso: async (context) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.get(`/tdu/termo-uso`);

    return resposta;
  },

  buscarAssinaturaTermo: async (context) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.get(`/tdu/termo-uso/check-assinatura`);

    return resposta;
  },

  assinarTermo: async (context) => {
    const api = context.rootState.autenticacao.api;
    const resposta = await api.put(`/tdu/termo-uso/assinar`);

    return resposta;
  },

  buscarTermoAtivo: async (context) => {
    const api = context.rootState.autenticacao.api;
    let resposta = await api.get(`/tdu/termo-uso/ativo`);

    return resposta;
  },
};

export const termo = {
  namespaced: true,
  state,
  actions,
  mutations,
};
